import React, { Component } from 'react';
import { Col, Row, Image, Modal } from 'react-bootstrap';
import JoinTeam from "./joinTeam";
import { CardFormIncButton } from "../../ui/templates/card";
import FunFees from "./funFees";
import moment from "moment";
import { Box } from '@material-ui/core';
import { fontStyleHeading } from '../../ui/constants';
import { Loading } from '../../ui/loader';

class EventDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedImage: null,
    };
  }

  handleImageClick = (imageLink) => {
    this.setState({
      showModal: true,
      selectedImage: imageLink,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      selectedImage: null,
    });
  };

  render() {
    const { event, teams, allTeams, onJoinToEvent, check,isLoading,isLoggedIn } = this.props;
    const { showModal, selectedImage } = this.state;
    if (isLoading) {
      return <Loading loading={ isLoading} />
    }
    return (
      <Box border="1px solid #DCDCDC" className="rightMemberAreaScreen">
        <Box style={fontStyleHeading}  p={2} borderBottom="1px solid #DCDCDC">
          {!check.isParticipate ? "Join Team" : "Event Details"}
        </Box>
        {event && (
          <Box>
            {teams && allTeams && !check.isParticipate ? (
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <JoinTeam
                    onJoinToEvent={onJoinToEvent}
                    event={event}
                    teams={teams}
                    allTeams={allTeams}
                  />
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CardFormIncButton
                    id={event.id}
                    image={event.eventLogo}
                    title={event.title}
                    date={
                      moment(event.startDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(event.endDate).format("DD/MM/YYYY")
                    }
                    address={event.address}
                    description={event.description}
                    details={event.urlEventPage}
                    map={event.map_link}
                    isLoggedIn={isLoggedIn}
                  />
                </Col>
              </Row>
            ) : (
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CardFormIncButton
                    id={event.id}
                    image={event.eventLogo}
                    title={event.title}
                    date={
                      moment(event.startDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(event.endDate).format("DD/MM/YYYY")
                    }
                    address={event.address}
                    description={event.description}
                    details={event.urlEventPage}
                    map={event.map_link}
                    isLoggedIn={isLoggedIn}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col xl={6} lg={6} md={12} sm={12} xs={12} className="order-lg-2">
                <Box m={[2, 2, 2, 4]}>
                  <Image
                    className="agenda_image"
                    src={event.agenda_image_link}
                    rounded
                    fluid
                    onClick={() =>
                      this.handleImageClick(event.agenda_image_link)
                    }
                  />
                </Box>
              </Col>
              <Col xl={6} lg={6} md={12} sm={12} xs={12} className="order-lg-1">
                <Box pl={[0, 0, 0, 2]}>
                  <FunFees event={event} />
                </Box>
              </Col>
            </Row>
          </Box>
        )}
        <Modal show={showModal} onHide={this.handleCloseModal} size="lg">
          <Modal.Body>
            <Image
              src={selectedImage}
              className="modal-image"
              width={"100%"}
              height={"100%"}
            />
          </Modal.Body>
        </Modal>
      </Box>
    );
  }
}

export default EventDetails;
